// OTU Languages

const en = {

    site_name: 'Online Therapy UNIT',
    urgent_care: 'URGENT CARE',

    previous: 'Previous',
    next: 'Next',
    continue: 'Continue',
    exit: 'Exit',
    play: 'Play',
    stop: 'Stop',
    choose_speed: 'Choose Playback Speed',
    speed: 'Speed',

    save_button: 'Save',
    cancel_button: 'Cancel',
    delete_button: 'Delete',
    back_button: 'Back',
    send_request: 'Send Request',
    file_label: 'File',
    size_label: 'Size',

    show_menu: 'Show Menu',
    main_menu: {
        menu: 'Menu',
        welcome: 'Welcome',
        courses: 'Courses',
        messages: 'Messages',
        profile: 'Profile',
        videos: 'Videos',
        log_out: 'Log Out'
    },

    fields: {
        first_name: 'First name',
        last_name: 'Last name',
        email_address: 'Email address',
        email_confirm: 'Confirm email address',
        province: 'Province',
        password: 'Password',
        password_confirm: 'Password Confirmation',
        password_strength: 'Password Strength: To be accepted, the meter below your New Password must be green, representing a strong password. You may increase the strength of your password by increasing its length and including uppercase and lowercase letters, numbers, and symbols.',
        preferred_language: 'Preferred Language',
        language_label_en: 'English',
        language_label_fr: 'French',
        lang_toggle: 'To change your language preference, toggle language at the top-right of the page.',
        user_type: "Which best describes you?",
        therapist_assistant: "Would you like the option to connect with a therapist by secure email or phone calls during the course?",
        course_interest: "Which of our courses are you primarily interested in at this time?",
        label_select_msg: "Please select",
        label_yes: "Yes",
        label_no: "No",

        errors: {
            username: 'Username is required',
            first_name: 'First name is required',
            last_name: 'Last name is required',
            email_address: 'Email address is required',
            email_match: 'Email addresses don\'t match',
            password: 'Password is required',
            password_confirm: 'Passwords don\'t match',
            password_strength: 'Password is not strong enough',
            assistance_availability_note: 'Based on your responses, therapist assistance is not available to you at this time'
        },
        success: {}
    },

    login: {
        header: 'Client Login',
        username: 'Login Username',
        password: 'Login Password',
        signin_button: 'Sign In',
        forgot: 'Forgot Username or Password?',
        new_client: 'New Client? Create an Account',

        new_clients_title: 'New Clients',
        new_clients_text: 'We offer adults free Online Cognitive Behaviour Therapy for depression, anxiety, and or pain. Online Cognitive Behaviour Therapy involves reviewing educational material online with the support of a therapist or a guide. The approach is found to be effective and is a convenient way to receive care.',
        new_clients_link: 'Account Signup',

        existing_clients_title: 'Existing Clients',
        existing_clients_text1: {
            before: 'If you\'re an existing client, having problems logging in or have technical difficulties in general, you can',
            link: 'request your username/reset your password.',
            after: ''
        },
        existing_clients_text2: {
            before: 'Still experiencing problems,',
            link: 'contact us',
            after: 'for more help.'
        },

        forgot_title: 'Forgot Your Username or Password?',
        forgot_email: 'Email address',

        back: 'Back to Login',

        errors: {
            no_access: 'Your account does not have access to this system.',
            account_email: 'We have sent a password reset link to your email address. Please log in to your email account and use the link in the email to reset your password. If you have not received the email, check your spam or junk email folders. If you do not receive a password reset link, please contact us at Online.Therapy.UNIT@uregina.ca for assistance.',
            account_terminated: 'Your account has been closed. Please contact OTU to reactivate your account if this is in error.',
            account_not_confirmed:'Your account has not been confirmed. Please check your email spam or junk folders for a confirmation email or contact OTU for help if you did not receive a confirmation email.',
            account_error_undefined:'If you are having troubles logging in, please contact OTU.'
        }
    },

    create_account: {
        header: 'Create an Account',
        self_enrol_title: 'Self Enrollment',
        self_enrol_text: 'Please fill out the form below to create your account. After completing the application, you will receive an email at the address you’ve provided. Follow the link in the email to confirm your account and complete the self-enrollment process. To avoid any errors, please check that the email address you’ve provided is correct before proceeding.',
        preflight_questions: [],
        preflight_error: 'You must agree to all the terms and select your province and user type to proceed.',
        preflightquestion1_error: 'You must agree you are 18 years old to proceed.',
        province_error:'Please select a value for provice to continue',
        client_source_error: 'Please select a value for which best describes you to continue',
        therapist_assistant_error: 'Please select a value for therapist assistance to continue',
        course_interests_error: 'Please select value for courses you are primarily interested in at this time',
        button: 'Create Account',

        created_title: 'Account Created',
        username: 'Username',
        created_text_1: 'Your account has been created. You need to confirm your account to access our site.',
        created_text_2: 'We have sent an account confirmation link to your email address. Please follow the instructions in the account confirmation email to confirm your account. If you have not received the email, check your spam or junk email folders. ',
        created_text_3_highlighted: 'Please note for security purposes, your email will not work as a username, so please take note of this system-generated username,',
        created_text_3: 'as you will need it to log in to the website once you confirm your account. If you require assistance, please contact us at ',
        
        table_therapist_heading: 'Therapist-Assisted PSP Wellbeing Course, PTSD Course or PSP Sleep Course',        
        table_condition1: 'English and French',
        table_condition1_temp:' (The PSP Sleep Course is currently in English only)',
        table_condition2: '18+',        
        table_therapist_condition3: 'Current or Former Public Safety Personnel (PSP)',
        table_therapist_condition4: 'NS/NB/ON/PEI/QC/SK',
        table_therapist_condition5: 'Includes therapist support',
        table_therapist_step1: 'Continue to create an account below.',
        table_therapist_step2: 'Look for an email to confirm your account.',
        table_therapist_step3: 'Complete an online consent and questionnaires in the language you want services in.',
        table_therapist_step4: 'PSP Wellbeing Course or PTSD Course – Schedule a telephone intake.',
        table_therapist_step5: 'PSP Sleep Course - Look for an email with next steps in 1-3 days.',

        table_selfguided_heading: 'Self-Guided PSP Wellbeing Course',
        table_selfguided_condition3: 'Current or Former PSP',
        table_selfguided_condition4: 'All of Canada',
        table_selfguided_condition5: 'Does NOT include therapist support',
        table_selfguided_step1_1: 'Click ',
        table_selfguided_step1_2: 'here ',
        table_selfguided_step1_3: 'to complete the online consent and screening questionnaires.',
        table_selfguided_step2: 'Wait for your eligibility email in 1-3 days.',
        
        table_spouse_heading: 'Self-Guided Spouse or Significant Other Wellbeing Course',
        table_spouse_condition1: 'English and French',
        table_spouse_condition3: 'Spouse or Significant Other of a current of former PSP',
        table_spouse_condition4: 'All of Canada',
        table_spouse_condition5: 'Does NOT include therapist support',
        table_spouse_step1: 'Email pspnetfamilies@pspnet.ca with your full name and preferred email address.',
        table_spouse_step2: 'Look for an email with your login information.',
        table_spouse_step3: 'Login and complete an online consent and screening questionnaires.',
        table_spouse_step4: 'Look for your eligibility email in 1-3 days.',

        table_note: '*To avoid errors or delays with the sign-up process, please check that your email is correctly entered before proceeding. To create an account, you will be asked some basic questions, so we can enroll you in the appropriate screening program. If you have any questions about our sign-up or eligibility screening procedures or having troubles creating your account, please email us at pspnet@uregina.ca or pspnetfamilies@uregina.ca or call us at 306-337-7233 or 1-833-317-7233',
    
    },

    confirm_account: {
        header: 'Confirm Account',
        title: 'Account Confirmation',
        confirmed: '<span class="font-weight-bold">Account Confirmed!</span> Please login to continue.',
        not_confirmed: '<span class="font-weight-bold">Confirmation Failed!</span> Either you already confirmed your account or your code isn\'t valid.',
    },

    forgot_password: {
        header: 'Forgot Password',
        title: 'Account Password Change',
        error: 'Password Token is invalid',
        success: '<span class="font-weight-bold">Password Reset!</span> Please login to continue.',
        button: 'Change Password'
    },

    dashboard: {
        header: 'Welcome',
        welcome_title: 'Welcome to Online Therapy!',
        messages_title: 'Messages',
        messages_inbox: {
            before: 'Check your',
            link_text: 'inbox',
            after: 'for new messages.'
        },
        messages_unread: {
            before: 'You have',
            link_text: '{unread} unread message(s).'
        },
        contacts_title: 'Your Contacts',
        contact_enrol: {
            before: 'You are signed up for',
            link_text: '.',
        },
        contact_not_enrol: {
            before: 'You are not currently enrolled. Click on ',
            link_text: 'Courses ',
            after: 'to find out more'
        },
        contacts_text: 'The following Online Therapy Staff have been assigned to assist you:',
        contacts_text_no_match: 'If you need to get in touch with us for technical assistance, you can contact us at the email below:',

        login_title: 'Last Login',
        last_login: 'You previously logged in on <strong>{last_login}</strong>.',
        login_suspect: 'If you suspect this to be incorrect and/or that someone might be accessing your account without your consent, do not hesitate to <a href="mailto:{email}">contact the unit</a>.',

        logout: {
            before: 'Please be sure to',
            link_text: 'Log Out',
            after: "once you've finished your work."
        },
        furthest_title: 'Pick up where I left off',
        SlidePosition: 'SlidePosition'
    },

    forums: {
        forum: 'Forum',
        select_forum: 'Select Forum',
        select_topic: 'Select Topic',
        title_topic: 'Topic:',
        section: 'Section:',
        topic: 'Topic',
        topics: 'Topics',
        posts: 'Posts',
        post: 'Post',
        add_post: 'Add Post',
        add_topic: 'Add Topic',
        section_click_message: 'Click to access Sections',
        report_post: 'Report Post',
        forum_not_assigned: 'No forums assigned'
    },

    courses: {
        header: 'Courses',
        missing: 'Sorry, the course your looking for doesn\'t exist.',

        begin: 'Begin',
        resume: 'Resume',
        open: 'Open',
        withdraw: 'Withdraw',
        grayscale: 'Grayscale',

        header_prescreen: 'Pre-Screen Self Enrollment',
        content_prescreen: '',
        no_prescreens: 'No Pre-Screens are currently available for self-enrollment.',
        prescreen_success: 'You are now enrolled in the Pre-Screen',
        prescreen_error: 'There was an error Enrolling you into the Pre-Screen',

        header_active: 'My Courses',
        content_active: 'Below is a list of the course(s) you are currently enrolled in. To continue with your course, click the blue button.',
        title_upcoming: 'My Upcoming Courses',
        title_past: 'My Past Courses',
        none_available: 'No Active or Enrollable Courses Available',
        stage_complete: 'Completed',
        stage_available: 'Available',

        shared_files_header: 'Shared Files',
        add_shared_file_title: 'Add Shared file',
        add_shared_file_success: 'Shared file added',
        add_shared_file_failed: 'File type not allowed',


        back: 'Back to My Courses',

        welcome_to: 'Welcome to {program_name}',

        survey_due: 'Survey Due',
        survey_no_delay: 'No Delay Found',
        surveys_text: 'To access course materials, please complete the surveys below:',
        survey_load_error: 'There was an error loading the survey.',
        surveys_completed: 'Completed Surveys',
        survey_complete: 'Survey Complete!',
        survey_complete_btn: 'Complete',

        additional_resources: 'Additional Resources',

        additional_resources_instruction: 'Left click to open file',
        additional_resources_recommended: 'Recommended',
        additional_resources_recommended_message: 'Recommended for you',
        additional_resources_last_accessed: 'Last accessed on ',
        additional_resources_never_accessed: 'Never accessed',

        withdraw_title: 'Are you sure?',
        withdraw_text: 'This withdrawal can not be undone. Someone from the unit may call you to discuss your withdrawal.',
        withdraw_confirm: "We're sorry to see you go. Please tell us why you are choosing to withdraw:",
        withdraw_success_title: 'Withdrawl Successful!',
        withdraw_success: 'You have been removed from the program.',
    	withdraw_error: 'You must enter a reason for withdrawl.',
        withdraw_button: 'Yes, Withdraw!',
        withdraw_cancel_button: 'Cancel!',
        withdraw_error_title: 'Withdrawl Error!',
        withdraw_ok_button: 'Ok',


		unavailable: '{program_name} is temporarily unavailable',

        content_begin: 'Let\'s Begin',
        toc: 'Table of Contents',
        slide: 'Slide',
        page: 'Page',
        of: 'of', // Page 1 of 2
        jump: 'Jump to...',

        overview_back: 'Back to Overview',
        go_to_additional_resources: 'Go to Additional Resources',

        file_attach: 'File Attachments',

        measures_title: 'Graphs'
    },

    messages: {
        header: 'Messages',
        manage_folders: 'Manage Folders',
        delete_folder: 'Delete Folder',
        delete_folder_confirm: 'Do you REALLY want to Delete the selected Folder and All Messages within?',

        folders: {
            40: 'Inbox',
            30: 'Sent',
            20: 'Drafts',
            10: 'Trash'
        },

        new_folder: 'New Folder',
        new_folder_name: 'New Folder Name',
        create_folder: 'Create Folder',
        folder_added: 'Folder Added',
        folder_saved: 'Folder Saved',
        folder_deleted: 'Folder Deleted',

        no_messages: 'No messages to see here...',
        messages_label: 'Messages',


        send_button: 'Send Mail',
        compose_button: 'Compose',
        reply_button: 'Reply',
        delete_button: 'Delete',
        undelete: 'Un-Delete',
        move_button: 'Move to',
        save_draft_button: 'Save Draft',
        cancel_draft_button: 'Cancel Draft',

        to: 'To',
        subject: 'Subject',

        draft_saved: 'Draft message saved',
        delete_confirm_title: 'Delete Messages',
        delete_confirm_msg: 'Do you REALLY want to Delete the selected messages?',

        no_matched_users: 'You have no matched therapists to send a message to. Please contact Online.Therapy.UNIT@uregina.ca for technical support.',

        messages: {
            none_selected: 'No messages selected.',
            moved: 'Message(s) moved.',
            undeleted: 'Message Un-Deleted.',
            msg_deleted: 'Message Deleted.',
            msgs_deleted: 'Messages Deleted.'
        }
    },

    profile: {
        header: 'Profile',
        title: 'Update Your Profile',

        language: 'Preferred Language',

        first_name: 'First name',
        last_name: 'Last name',
        phone_home: 'Home phone number',
        phone_work: 'Work phone number',
        phone_cell: 'Cell phone number',
        phone_preferred: 'Preferred phone #',
        phone_alternate: 'Alternate phone #',
        gender: 'Gender',
        address: 'Address',
        province: 'Province',
        save_profile: 'Save Profile',

        email_title: 'Change Your Email Address',
        email_address: 'Email address',
        email_confirm: 'Confirm email address',
        email_note: 'Be sure the new email address is correct before saving.',
        save_email: 'Save Email Address',

        nickname_forum_title: 'Change Your Nickname For Forums',
        nickname_forum_label: 'Nickname (Forums)',
        nickname_disclaimer: 'If you choose to add a nickname, please do not use your real name or any other information that could reveal your identity.',
        save_nickname_forum: 'Save',
        phone_no_disclaimer:"Please only include information that you are authorizing OTU to contact you at.",

        password_title: 'Change Your Password',
        password_existing: 'Existing Password',
        password_new: 'New Password',
        password_old: 'Old Password',
        password_confirm: 'Password Confirmation',
        change_password: 'Change password',
        expired_password: 'Password reset is required below.',

        messages: {
            setting_failed: 'Failed to save: {key}',
            saved: 'Profile Saved',

            email_no_match: 'Email address and Confirmation Email does not match.',
            email_saved: 'Email Address Changed',
            nickname_forum_saved: 'Nickname for forums updated',
            email_failed: 'Your email was NOT updated.',

            pass_existing_req: 'Existing password is required',
            pass_new_req: 'New password is required',
            pass_match: 'New passwords do not match',
            pass_strength: 'Password is not strong enough.',
            pass_changed: 'Password changed',
            pass_change_failed: 'Password change failed'
        }
    },
    videos: {
        header: 'Videos',
    },
    footer: {
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        forum_terms: 'Forum Terms of Use',
        faq: 'FAQ',
        copyright: '2019-2020 Online Therapy Unit'
    }

}

export { en };
